<template>
    <div class="div-reply">
        <v-row justify="start">
            <v-chip-group show-arrows>
                <v-chip v-for="(tag, index) in list_quickreply.quick_reply" :key="`${index}-${tag.type}`" class="ma-1"
                    color="#2463af" outlined @click="sendQuickReply(tag, index)" :loading="loading[index]">
                    <v-icon left v-if="checkIconType(tag.type) !== ''"
                        class="fz-16">{{ checkIconType(tag.type) }}</v-icon>
                    {{ tag.label }}
                </v-chip>
            </v-chip-group>

            <v-dialog
              ref="dialog"
              v-model="DateModal"
              :return-value.sync="date"
              persistent
              width="290px"
            >
              <v-date-picker
                v-model="date"
                scrollable
                :max="maxDate"
                :min="minDate"
                :locale="locale"
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="grey"
                  @click="DateModal = false"
                >
                  {{$t('AnswerQuestion.cancel')}}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialog.save(date), senddate()"
                >
                {{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-date-picker>
            </v-dialog>

            <v-dialog
              ref="dialogtime"
              v-model="TimeModal"
              :return-value.sync="timeselect"
              persistent
              width="290px"
            >
              <v-time-picker
                v-model="timeselect"
                full-width
              >
                <v-spacer></v-spacer>
                <v-btn
                  text
                  color="grey"
                  @click="TimeModal = false"
                >
                {{$t('AnswerQuestion.cancel')}}
                </v-btn>
                <v-btn
                  text
                  color="primary"
                  @click="$refs.dialogtime.save(timeselect), sendtime()"
                >
                {{$t('AnswerQuestion.ok')}}
                </v-btn>
              </v-time-picker>
            </v-dialog>
        </v-row>
        <div style="display: none;">
          <input multiple type="file" id="ocr" @change="sendFileAndImage($event, 'ocr')" accept="image/*" />
          <input multiple type="file" id="image" @change="sendFileAndImage($event, 'image')" accept="image/*" />
          <input multiple type="file" id="file" @change="sendFileAndImage($event, 'file')" />
        </div>
        <WebviewBigOcrDialog :tokenuser="tokenuser" :tokenroom="tokenroom" :dialogWebviewbig_ocr="dialogWebviewbig_ocr" :Webview_item="Webview_item_ocr" @closewebview="closewebview"></WebviewBigOcrDialog>
        <WebviewBigDialogVue :tokenuser="tokenuser" :tokenroom="tokenroom" :dialogWebviewbig="dialogWebviewbig" :Webview_item="Webview_item" @closeWebview="closeWebview"></WebviewBigDialogVue>
        <CheckBrowserDialog :checkBrowserDialog="checkBrowserDialog" :checkBrowserInfor="checkBrowserInfor" @closeCheckBrowser="closeCheckBrowser"></CheckBrowserDialog>
        <DetailFriend :DetailFriendDialog="DetailFriendDialog" :InforFriend="InforFriend" @closeComponents="closeComponents"></DetailFriend>
    </div>
</template>
<script>
import { Momenttime, Encode } from "@/services"
import WebviewBigOcrDialog from "@/components/dialog/WebviewOcrDialog.vue"
import WebviewBigDialogVue from "@/components/dialog/WebviewBigDialog.vue"
import CheckBrowserDialog from "@/components/dialog/CheckBrowserDialog.vue";
import DetailFriend from '@/components/DetailFriend.vue';

export default {
    props: {
        list_quickreply: Object,
        tokenroom: String,
        tokenuser: String,
        data_user: Object
    },
    components: {
      WebviewBigOcrDialog,
      WebviewBigDialogVue,
      CheckBrowserDialog,
      DetailFriend,
    },
    data: () => ({
      DetailFriendDialog: false,
      InforFriend: {},
      loading: [],
      date: "",
      minDate: "",
      maxDate: "",
      DateModal: false,
      TimeModal: false,
      locale: "",
      typepicker: "",
      minTime: "",
      maxTime: "",
      infodata: "",
      timeselect: "",
      file: null,
      dialogWebviewbig_ocr: false,
      Webview_item_ocr: {},
      checkBrowserDialog: false,
      checkBrowserInfor: {},
      Webview_item: {},
      dialogWebviewbig: false,
      InforFriend: {},
      DetailFriendDialog: false,
      dialogLogin: false,
    }),
    created() {
      this.locale = (this.$cookie.get('language')) ? this.$cookie.get('language') : 'th'
    },
    methods: {
      closeComponents () {
        this.DetailFriendDialog = false
        this.InforFriend = {}
      },
      async closeWebview(value) {
        await this.ans_quickreply(this.infodata, this.infodata.index)
        this.dialogWebviewbig = false
        this.Webview_item = {}
      },
      async closewebview(value) {
        await this.ans_quickreply(this.infodata, this.infodata.index)
        this.Webview_item_ocr = {}
        this.dialogWebviewbig_ocr = value
      },
      async sendQuickReply(item, index) {
        if (item.type === 'datepicker' || item.type === 'datetimepicker') {
          this.selectDateTime(item, index) 
        } else if (item.type === 'image' || item.type === 'file') {
          // console.log("select file");
          this.infodata = item
          document.getElementById(`${item.type}`).click()
        } else if (item.type === 'ocr') {
          // item.index = index
          // this.infodata = item
          // document.getElementById('ocr').click()
          // ตัดออกเพราะ api ที่ใช้ยิง error
          this.$swal({
              type: "warning",
              text: this.$t('Alert.Warning.link_market'),
              showConfirmButton: true,
              allowOutsideClick: false,
              confirmButtonText: this.$t('AnswerQuestion.ok')
          })
        } else if (item.type === 'link' || item.type === 'webview') {
          item.index = index
          this.infodata = item
          if (item.type === 'link') {
            await this.ans_quickreply(item, index)
          }
          this.check_authen(item)
        } else {
          this.ans_quickreply(item, index)
        }
      },
      sendFileAndImage(data, type) {
        // console.log(`sendFileAndImage ${type} =>`, data);
        let uploadedFiles = data.target.files
        var lengthfile = uploadedFiles.length
        var sizefile = []
        for (var i = 0; i < lengthfile; i++) {
          sizefile[i] = uploadedFiles[i].size
        }
        if (_.sum(sizefile) / 1024 / 1024 > 100) {
          this.$swal({
            title: this.$t('Alert.Fail.Chat.maxSizeFile100'),
            type: 'warning'
          })
        } else {
          for (let i = 0; i < lengthfile; i++) {
            if (type == 'file' || type == 'image') {
              this.sendFile(type, uploadedFiles[i], process.env.VUE_APP_API_alpine + '/v1/answer_quickreply')
            } else {
              this.sendFileORC(uploadedFiles[i], 'https://l.one.th/onechat-ocr/api/v1/send-ocr-image')
            }
          }
        }
      },
      sendFileORC(data, path) {
        // console.log(this.ocr_detailItem)
        var me = this
        var reader = new FileReader();
        reader.readAsDataURL(data)
        reader.onloadend = function() {
          var body = {
            "tokenroom": me.tokenroom,
            "tokenuser": me.tokenuser,
            "base64_image": reader.result,
            "multi_select": me.infodata.multi_select !== undefined ? me.infodata.multi_select : null
          }
          me.dialogWebviewbig_ocr = true

          me.axios.post(path, body).then((response) => {
            // console.log(response.data.data.link)
            if (response.data.message === 'success') {
              // me.dialogWebviewbig = true
              me.Webview_item_ocr = {url: response.data.data.link, label: ''}
            }
          }).catch(error => {
            console.log(error);
              me.$swal({
                type: "warning",
                title: "Error",
                text: me.$t('Alert.Fail.default.somethingWrong'),
                showConfirmButton: true,
                allowOutsideClick: false,
                confirmButtonText: me.$t('AnswerQuestion.ok')
            });
          })
        }
      },
      async sendFile(type, uploadedFiles, path) {
        var uploadFile = new FormData()
        uploadFile.append('file', uploadedFiles, uploadedFiles.name)
        uploadFile.append('tokenroom', this.tokenroom)
        uploadFile.append('tokenuser', this.tokenuser)
        uploadFile.append('type_reply', type)
        uploadFile.append('info_data', this.infodata.payload)
        
        await this.axios.post(path, uploadFile).then((response) => {
          if (response.data.status === 'success') {
          } else {
            this.$swal({
                type: "warning",
                title: `Error ${response.data.status}`,
                text: response.data.message,
                showConfirmButton: true,
                allowOutsideClick: false,
                confirmButtonText: this.$t('AnswerQuestion.ok')
            });
          }
        }, (error) => {
          console.log(error)
          this.$swal({
              type: "warning",
              title: `Error ${error.response.data.status}`,
              text: error.response.data.message,
              showConfirmButton: true,
              allowOutsideClick: false,
              confirmButtonText: this.$t('AnswerQuestion.ok')
          });
        })
      },
      momentday (date) {
        return Momenttime.dayjsdatetimethai(date)
      },
        emitMessage(type, data, index) {
            // console.log("emit =>", data);
            if (type === 'location') {
                data.tokenroom = this.tokenroom
                data.tokenuser = this.tokenuser
                this.sendLocation(data, index)
            }
        },
        senddate() {
          // var _ = require('lodash')
          if (this.typepicker === 'datepicker') {
            // api
            this.DateModal = false
            this.$swal({
              title: this.$t('Alert.Chat.sendDatetime'),
              html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.date) + '</div>',
              confirmButtonColor: '#3085d6',
              confirmButtonText: this.$t('AnswerQuestion.ok'),
              cancelButtonColor: '#d33',
              cancelButtonText: this.$t('AnswerQuestion.cancel'),
              buttonsStyling: true,
              showCloseButton: true,
              showCancelButton: true,
              reverseButtons: true,
              allowOutsideClick: false
            }).then((result) => {
              if (result.value) {
                var item = {
                  message: this.date,
                  payload: this.infodata,
                  type: 'datepicker'
                }
                this.ans_quickreply(item, 0)
              }
            })
          } else if (this.typepicker === 'datetimepicker') {
            this.DateModal = false
            this.TimeModal = true
            if (this.date === this.minDate) {
              this.maxTime = '24:00'
            } else if (this.date === this.maxDate) {
              this.minTime = '00:00'
            } else {
              this.maxTime = '24:00'
              this.minTime = '00:00'
            }
          }
        },
        sendtime() {
          this.$swal({
            title: this.$t('Alert.Chat.sendDatetime'),
            html: '<br><div class="CSChatThai" style="text-align:left">' + this.momentday(this.date) + ' เวลา ' + this.timeselect + '</div>',
            confirmButtonColor: '#3085d6',
            confirmButtonText: this.$t('AnswerQuestion.ok'),
            cancelButtonColor: '#d33',
            cancelButtonText: this.$t('AnswerQuestion.cancel'),
            buttonsStyling: true,
            showCloseButton: true,
            showCancelButton: true,
            reverseButtons: true,
            allowOutsideClick: false,
          }).then((result) => {
            if (result.value) {
              var item = {
                message: this.date + 'T' + this.timeselect,
                payload: this.infodata,
                type: 'datetimepicker'
              }
              this.timepicker = false
              this.ans_quickreply(item, 0)
            }
          })
        },
        selectDateTime(data, index) {
          // console.log(`selectDateTime ${index} =>`, data)
          // setTimeout(this.scrollDown, 1)
          // this.loading[index] = true;
          if (data.type === 'datepicker') {
            this.typepicker = data.type
            this.DateModal = true
            this.maxDate = data.max
            this.minDate = data.min
            this.date = data.initial
            this.infodata = data.payload
          } else if (data.type === 'datetimepicker') {
            this.typepicker = data.type
            this.DateModal = true
            this.maxDate = data.max.split('T')[0]
            this.minDate = data.min.split('T')[0]
            this.maxTime = data.max.split('T')[1]
            this.minTime = data.min.split('T')[1]
            this.date = data.initial.split('T')[0]
            this.timeselect = data.initial.split('T')[1]
            this.infodata = data.payload
          }
        },
        sendLocation(item, index) {
            // console.log("sendLocation =>", item);
            this.loading[index] = true;
            // insert ข้อความก่อนที่จะส่ง เพื่อทำ loading
            this.axios.post(process.env.VUE_APP_API_ALPINE + `/api/v1/pushLocation`, item).then((response) => {
                // console.log(response.data)
                if (response.data['status'] === 'success') {
                  this.loading[index] = false;
                }
            }).catch(err => {
                this.progress = false
                this.$swal({
                    type: "warning",
                    title: `Error ${err.response.data.status}`,
                    text: this.$t('Alert.Fail.default.somethingWrong'),
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonText: me.$t('AnswerQuestion.ok')
                });
            })
        },
        async ans_quickreply(item, index) {
            // console.log("ans_quickreply =>", item)
            var body = {
                tokenroom: this.tokenroom,
                tokenuser: this.tokenuser,
                type_reply: item.type,
                message: item.message,
                info_data: item.payload
            }
            await this.axios.post(process.env.VUE_APP_API_alpine + '/v1/answer_quickreply', body).then((response) => {
                if (item.type == 'text') {
                    this.$emit('emitMessage', { methods: 'insertmessage', value: response.data.data })
                } else if (item.type === 'location') {
                    // console.log("window.navigator.geolocation =>", window.navigator.geolocation);
                    if (window.navigator.geolocation) {
                        var me = this
                        window.navigator.geolocation.getCurrentPosition(function (position) {
                            var location = {};
                            const lat = position.coords.latitude;
                            const lon = position.coords.longitude;

                            // ใช้ Google Maps Geocoding API
                            const apiKey = "AIzaSyBUh61FWG3kr4BSAEO_NRrniSz8S5ceLic";
                            const language = me.$i18n.locale !== undefined ? me.$i18n.locale : 'th'; // ภาษาไทย
                            const url = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lon}&language=${language}&key=${apiKey}`;
                            
                            fetch(url)
                              .then((response) => response.json())
                              .then((data) => {
                                if (data.results.length > 0) {
                                  // console.log("สถานที่:", data.results[0]);
                                  location = {
                                    lat: position.coords.latitude.toString(),
                                    long: position.coords.longitude.toString(),
                                    address: data.results[0].formatted_address,
                                  };
                                  me.emitMessage('location', location, index)
                                } else {
                                  console.log("ไม่พบข้อมูลสถานที่");
                                  location = {
                                    lat: position.coords.latitude.toString(),
                                    long: position.coords.longitude.toString(),
                                    address: "",
                                  };
                                  me.emitMessage('location', location, index)
                                }
                              })
                              .catch((error) => console.error("Error:", error));
                        },
                            function (error) {
                                console.log(error);
                                var me = this
                                me.$swal({
                                    type: "warning",
                                    text: 'Onechat needs access to use your current location, Please allow your location.',
                                    showConfirmButton: true,
                                    allowOutsideClick: false,
                                    confirmButtonText: me.$t('AnswerQuestion.ok')
                                });
                            })
                    }
                } else if (item.type === 'link_market') {
                    this.$swal({
                        type: "warning",
                        text: this.$t('Alert.Warning.link_market'),
                        showConfirmButton: true,
                        allowOutsideClick: false,
                        confirmButtonText: this.$t('AnswerQuestion.ok')
                    })
                } else if (item.type === 'ekyc') {
                    this.ans_ekyc_template(item, this.list_quickreply.tokenuser)
                }
            }).catch(err => {
                console.log(err)
                this.$swal({
                    type: "warning",
                    text: err.response.data.message,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonText: this.$t('AnswerQuestion.ok')
                })
            })
        },
        async check_authen(item) {
          if (item.sign === 'true') {
            var body = {
              tokenuser: this.tokenuser,
              url: item.url
            }
            await this.axios.post(process.env.VUE_APP_API_alpine + '/v1/getAccesstoken', body).then((response) => {
              if (response.data.data) {
                var new_url = response.data.data.url
                this.checktypeOpenweb(new_url, item)
              } else {
                // this.dialogLogin = true
                this.$swal({
                    type: "warning",
                    text: this.$t('Setting.messageEditPhone.MsgTokenExpire'),
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonText: this.$t('AnswerQuestion.ok')
                })
                // .then((value) => {
                //   if (value) {
                //     this.$cookie.delete('login-page')
                //     this.$cookie.delete('one_token')
                //     var path = `${process.env.VUE_APP_URL_PRIVATE}/login?business_id=${this.data_user.one_id}&status_login=false`
                //     window.open(path, '_self')
                //   }
                // })
              }
            }, (error) => {
              this.$swal({
                    type: "warning",
                    text: error.response.data.message,
                    showConfirmButton: true,
                    allowOutsideClick: false,
                    confirmButtonText: this.$t('AnswerQuestion.ok')
                })
            })
          } else if (item.onechat_token === 'true') {
            var expireddate = Encode.ExpiredDataOnechatToken()
            var body = Encode.encodeRichmenu({
              'userid': this.tokenuser,
              'expired_date': expireddate
            })
            var url = ''
            if (_.includes(item.url, ['?'])) {
              url = '&'
            } else {
              url = '?'
            }
            var weburl = item.url + url + 'onechat_token=' + body + '&' + 'expired_date=' + expireddate
            this.checktypeOpenweb(weburl, item)
          } else {
            this.checktypeOpenweb(item.url, item)
          }
        },
        checktypeOpenweb(link, item) {
          // console.log('checktypeOpenweb: ', item)
          // console.log('link: ', link)
          if (item.type === 'link') {
            // window.open(link, '_blank')
            try {
              const data_sign = { message: link }
              const result_sign = window.flutter_inappwebview.callHandler('op_openwebview', data_sign);
            } catch (e) {
              this.checkBrowser(link, item)
            }
          } else if (item.type === 'webview') {
            this.Webview_item = {
              label: item.label,
              url: link,
              size: item.size,
              type: item.type
            }
            this.dialogWebviewbig = true
          }
        },
        ans_ekyc_template(item, tokenbot) {
          this.axios.post(process.env.VUE_APP_API_message + '/api/v1/get_shared_token', {
            user_id: this.data_user.one_id
          }).then((response) => {
            if (response.data.status === 'success') {
              var url = `${process.env.VUE_APP_API_Oneid_EKYCbysharetoken}${response.data.data.shared_token}&bot_id=${tokenbot}`
              try {
                const data = { message: url }
                const result = window.flutter_inappwebview.callHandler('op_openwebview', data);
                // Handle the successful result here
              } catch (error) {
                // Handle the error returned from the function
                console.error('Error: ', error);
                if (item.payload !== undefined) {
                  this.Webview_item = {
                    label: item.label,
                    url: url,
                    size: 'full',
                    type: 'ekyc',
                    payload: item.payload
                  }
                } else {
                  this.Webview_item = {
                    label: item.label,
                    url: url,
                    size: 'full',
                    type: 'ekyc',
                    payload: ''
                  }
                }
                this.checkBrowser(url, this.Webview_item)
              }
            }
          }).catch(error => {
            this.$swal('', this.$t('Alert.Fail.default.somethingWrong'), 'error')
          })
        },
        saveLogNews (item) {
          // console.log("saveLogNews", item);
          this.axios.get(process.env.VUE_APP_API_GO + '/v1/getOneID/' + this.tokenuser).then((response) => {
            var one_id = response.data.one_id
            // console.log(one_id)
            this.axios.post(process.env.VUE_APP_API_NEWS, {
              'one_id': one_id,
              'news_id': item.payload.news_id,
              'news_index': item.payload.news_index.toString(),
              'page_name': item.payload.page_name
            }).then((response) => {
              // console.log(response)
            }).catch(error => {
              console.log(error)
            })
          }, (error) => {
            console.log(error)
          })
        },
        closeCheckBrowser (value) {
          this.checkBrowserDialog = value
          this.checkBrowserInfor = {}
        },
        openMessage(type, item) {
          if (type === 'contact' || type === 'detailfriend') {
            this.axios.post(process.env.VUE_APP_API_MANAGE + `/searchtokenuser`, {
              tokenuser: this.tokenuser,
              tokenfriend: item.message
            }).then((response) => {
              if (response.data.status === 'success') {
                this.InforFriend = response.data['user']
                this.InforFriend.backPage = `/chat-web/${this.tokenroom}`
                this.InforFriend.path = `/chat-web/${response.data['user']['tokenroom']}`
                this.InforFriend.statemember = response.data.relation
                this.DetailFriendDialog = true
              }
            }).catch(err => {
              console.log(err)
            })
          }
        },
        checkBrowser (url, item) {
          // console.log(item)
          if (_.includes(url, `${process.env.VUE_APP_QRcode}/qrcode/friend?id=`)) {
            var link = _.split(url, '?id=', 2)
            var item_friend = {}
            item_friend.message = link
            this.openMessage('detailfriend', item_friend)
          } else {
            // Get the user-agent string
            let userAgentString = navigator.userAgent;
            // Detect Chrome
            let chromeAgent = userAgentString.indexOf("Chrome") > -1;
            // Detect Internet Explorer
            let IExplorerAgent = userAgentString.indexOf("MSIE") > -1 || userAgentString.indexOf("rv:") > -1;
            // Detect Firefox
            let firefoxAgent = userAgentString.indexOf("Firefox") > -1;
            // Detect Safari
            let safariAgent = userAgentString.indexOf("Safari") > -1;
            // Discard Safari since it also matches Chrome
            let operaAgent = userAgentString.indexOf("OP") > -1;
            if (firefoxAgent === true || IExplorerAgent === true || operaAgent === true) {
              if (item.payload !== undefined && item.payload !== null) {
                if (item.payload.news_id !== undefined) {
                  this.checkBrowserInfor = {
                    url: url,
                    payload: item.payload
                  }
                } else {
                  this.checkBrowserInfor = {
                    url: url
                  }
                }
              } else {
                this.checkBrowserInfor = {
                  url: url,
                  payload: ''
                }
              }
              this.checkBrowserDialog = true
            } else if (safariAgent === true && chromeAgent === true) {
                //  console.log('savelog')
                window.open(url, '_blank')
                if (item.payload !== undefined && item.payload !== null) {
                  if (item.payload.news_id !== undefined) {
                    this.saveLogNews(item)
                  }
                }
            } else if (safariAgent === true) {
              if (item.payload !== undefined && item.payload !== null) {
                if (item.payload.news_id !== undefined) {
                  this.checkBrowserInfor = {
                    url: url,
                    payload: item.payload
                  }
                } else {
                  this.checkBrowserInfor = {
                    url: url
                  }
                }
              } else {
                this.checkBrowserInfor = {
                  url: url,
                  payload: ''
                }
              }
              this.checkBrowserDialog = true
            } else {
              // console.log('savelog')
              window.open(url, '_blank')
              if (item.payload !== undefined && item.payload !== null) {
                if (item.payload.news_id !== undefined) {
                  this.saveLogNews(item)
                }
              }
            }
          }
        },
        checkIconType(type) {
            if (type == 'ekyc') {
                return 'fa-solid fa-user-shield'
            } else if (type == 'image') {
                return 'fa-solid fa-file-image'
            } else if (type == 'file') {
                return 'fa-solid fa-file'
            } else if (type == 'location') {
                return 'fa-solid fa-location-arrow'
            } else if (type == 'text') {
                return 'fa-solid fa-message'
            } else if (type == 'link') {
                return 'fa-solid fa-link'
            } else if (type == 'webview') {
                return 'fa-regular fa-window-maximize'
            } else if (type == 'datepicker' || type == 'datetimepicker') {
                return 'fa-solid fa-calendar-days'
            } else if (type == 'link_market') {
                return 'fa-solid fa-cart-shopping'
            } else {
                return ''
            }
        }
    },
}
</script>
<style scoped>
.fz-16 {
    font-size: 16px !important;
}

.div-reply {
    height: 45px;
    background-color: transparent;
    padding: 10px;
    bottom: 11px;
    position: relative;
}

.template {
    /* min-width: 95vw;
	max-width: 90vw; */
    width: 45%;
    overflow-x: scroll;
    overflow-y: hidden;
}

.template::-webkit-scrollbar {
    height: 6px;
    width: 4px;
    cursor: pointer;
}

.template::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: rgba(0, 0, 0, .1);
}
</style>